import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import * as _amplitude from '@amplitude/analytics-browser'
import {
  INFRASTRUCTURE_ENVIRONMENT_TYPE,
  SENTRY_DSN,
  FRONTEND_REVISION,
  AMPLITUDE_API_KEY,
  AMPLITUDE_PROD_API_KEY,
} from './constants'
import { setupMemoryMonitoring } from './utils/performance'
import { App } from './App'
import './index.css'

export const amplitude = _amplitude.createInstance()

const sentryOptions = {
  dsn: SENTRY_DSN,
  integrations: [],

  environment: INFRASTRUCTURE_ENVIRONMENT_TYPE,
  release: FRONTEND_REVISION,

  maxBreadcrumbs: 20,

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  tracesSampleRate: 0.5,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/buildquarter20\.com\/api/],

  // Capture Replay for 0% of all sessions,
  // plus for 0% of sessions with an error
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 0.0,

  // Set profilesSampleRate to 1.0 to profile every transaction.
  // Since profilesSampleRate is relative to tracesSampleRate,
  // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
  // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
  // results in 25% of transactions being profiled (0.5*0.5=0.25)
  profilesSampleRate: 0.5,
}

if (SENTRY_DSN && INFRASTRUCTURE_ENVIRONMENT_TYPE === 'prod') {
  amplitude.init(AMPLITUDE_PROD_API_KEY, { instanceName: 'prod' })
  Sentry.init({
    ...sentryOptions,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
    ],
  })
  setupMemoryMonitoring()
}

if (SENTRY_DSN && INFRASTRUCTURE_ENVIRONMENT_TYPE === 'stage') {
  amplitude.init(AMPLITUDE_API_KEY, { instanceName: 'stage' })
  Sentry.init({
    ...sentryOptions,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
    ],
  })
  setupMemoryMonitoring()
}

if (SENTRY_DSN && INFRASTRUCTURE_ENVIRONMENT_TYPE === 'test') {
  Sentry.init({
    ...sentryOptions,
    integrations: [Sentry.browserTracingIntegration()],
  })
  setupMemoryMonitoring()
}

ReactDOM.createRoot(document.getElementById('root')!).render(<App />)
